import {ImageType, ImageFile} from '../../model';
import styles from './FundraiserImageWithMenu.module.scss';
import {DropdownMenu, Icon} from '@gravity-ui/uikit';
import {TrashBin, Ellipsis, ArrowUpFromLine} from '@gravity-ui/icons';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';

interface FundraiserImageWithMenuProps {
  image: ImageFile;
  imageType: ImageType;
  allImages: ImageFile[];
  openImageViewer: (url: string, fileName: string, allImages: ImageFile[]) => void;
  handleDeleteImage: (imageType: ImageType, fileName: string) => Promise<void>;
  handleUploadNewImage?: (imageType: ImageType) => void;
  isDragDisabled?: boolean;
  aspectRatio?: number;
}

export const FundraiserImageWithMenu = ({
  image,
  imageType,
  allImages,
  openImageViewer,
  handleDeleteImage,
  handleUploadNewImage,
  isDragDisabled = false,
  aspectRatio,
}: FundraiserImageWithMenuProps) => {
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({
    id: image.fileName,
    disabled: isDragDisabled || imageType === ImageType.AVATAR,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  const getDropdownItems = () => {
    if (imageType === ImageType.AVATAR) {
      return [
        {
          iconStart: <Icon size={16} data={ArrowUpFromLine} />,
          action: () => handleUploadNewImage?.(imageType),
          text: 'Загрузить новую',
          className: styles.dropdownItem,
        },
      ];
    }

    return [
      {
        iconStart: <Icon size={16} data={TrashBin} />,
        action: () => handleDeleteImage(imageType, image.fileName),
        text: 'Удалить',
        className: styles.dropdownItemDelete,
      },
    ];
  };

  return (
    <div ref={setNodeRef} style={style} className={styles.imageWrapper} {...attributes}>
      {/* В карточке — уменьшенная копия; просмотр и «скачать» открывают базовое изображение по url */}
      <img
        src={image.thumbnailUrl ?? image.url}
        className={styles.image}
        alt={image.fileName}
        onClick={() => openImageViewer(image.url, image.fileName, allImages)}
        style={{cursor: 'pointer', aspectRatio: aspectRatio}}
      />
      <>
        {/* Область для перетаскивания */}
        {!isDragDisabled && imageType !== ImageType.AVATAR && <div className={styles.dragHandle} {...listeners} />}
        <div className={styles.imageMenu}>
          <DropdownMenu size="s" icon={<Icon size={15} data={Ellipsis} />} items={getDropdownItems()} />
        </div>
      </>
    </div>
  );
};
